import apiClient from '@api/apiClient';

const getPlans = async systemId => {
  try {
    const response = await apiClient.get(`plans?system_id=${systemId}`, {
      middleware: {withAuth: true},
    });
    const {data} = response || [];
    if (data) {
      return data;
    }
    return [];
  } catch (e) {
    console.log('API Error:', e);
    throw e;
  }
};

const addPlan = async ({planData, systemId}) => {
  try {
    const response = await apiClient.post(`plans/system/${systemId}/create`, planData, {
      middleware: {withAuth: true},
    });
    const {data} = response || {};
    if (data) {
      return data;
    }
    return {};
  } catch (e) {
    console.log('API Error:', e);
    throw e;
  }
};

const getPlan = async ({plan_id, system_id}) => {
  try {
    const response = await apiClient.get(`plans/${plan_id}?system_id=${system_id}`, {
      middleware: {withAuth: true},
    });
    const {data} = response || {};
    return data;
  } catch (e) {
    console.log('API Error:', e);
    throw e;
  }
};

export const editPlan = async ({plan_id, planData}) => {
  try {
    const response = await apiClient.put(`plans/${plan_id}`, planData, {
      middleware: {withAuth: true},
    });
    const {data} = response || {};
    return data;
  } catch (e) {
    console.log('API Error:', e);
    throw e;
  }
};

const deletePlan = async plan_id => {
  try {
    const response = await apiClient.delete(`plans/${plan_id}`, {
      middleware: {withAuth: true},
    });
    const {data} = response || {};
    return data;
  } catch (e) {
    console.log('API Error:', e);
    throw e;
  }
};

export const plansAPI = {
  getPlans,
  addPlan,
  getPlan,
  editPlan,
  deletePlan,
};
